module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projectTermJobs',
    },

    methods: {
        /**
         * will be called right before sanitizeForm() is done
         */
        onBeforeSanitizeForm(storage){
            if(storage.isServer){
                return
            }

            const fields = this.model.fields = this.model.fields || []
            fields.push({
                atom: {
                    dataType: 'json',
                },
                fieldCode: 'nrOfElementsPerJob'
            })
            fields.push({
                atom: {
                    dataType: 'datetime',
                },
                fieldCode: 'startTS'
            })
            fields.push({
                atom: {
                    dataType: 'datetime',
                },
                fieldCode: 'endTS'
            })
        },

        async customSubmit(data){
            if(((data || {}).data || {}).attributes){
                data.data.resourceParams = data.data.attributes
                delete data.data.attributes
            }

            return this.performAction(this.prepareAction('submit', undefined, undefined, {
                source: {
                    submit: {
                        data
                    },
                },
            }))
        }
    },
}